import axios from 'axios';

import { COMPANIES_V2, ROLE_CHANGE_REQUEST } from '../endpointsConst';

export interface CompanyTypeChangeRequest {
  /** UUID желаемого типа компании из справочника ролей */
  role_id: string;
  comment?: string;
}

const CompanyTypeService = {
  /**
   * Тип компании выбирается при регистрации, дальше его меняет только администратор:
   * запрос не меняет тип, а создаёт заявку в админку
   */
  requestTypeChange: (companyId: string, data: CompanyTypeChangeRequest) =>
    axios.post(`${COMPANIES_V2}/${companyId}${ROLE_CHANGE_REQUEST}`, data),
};

export { CompanyTypeService };
